var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Newsletter.Messages.Subscribe, Vendd.Newsletter, function (envelope) {

        var $email = envelope.message.data.email;

        var serviceOpts = {
            url: 'NewsLetterService.svc/Subscribe',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.SubscribeSuccess($.extend({},response, { 'email' : $email })));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.SubscribeFailure(response));
        };

        Vendd.Service.call(serviceOpts);
    });

    Vendd.MessageBus.subscribe(Vendd.Newsletter.Messages.UpdateNewLetterVariables, Vendd.Newsletter, function (envelope) {
        var options = {
            url: 'NewsLetterService.svc/UpdateNewsLetterVariables',
            data: {
                source: envelope.message.data.source,
                apiKey: envelope.message.data.apikey
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

        }
        function onFailure(response) {

        }

        var clientModel = Vendd.User && Vendd.User.GetClientModel();
        if (clientModel && clientModel.IsAuthenticated)
            Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Newsletter.Messages.Unsubscribe, Vendd.Newsletter, function (envelope) {

        var serviceOpts = {
            url: 'NewsLetterService.svc/Unsubscribe',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UnsubscribeSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UnsubscribeFailure(response));
        };

        Vendd.Service.call(serviceOpts);
    });

    return Vendd;

})(Vendd || {});